import { NextPage } from 'next'
import Link from 'next/link'
import { Alert } from 'react-bootstrap'
import { InquiryForm } from 'web_core/assets/inquiry'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useRequireSignedIn } from 'web_core/firebase/hooks'
import { HELP_NOTION_LINKS } from 'web_core/utils'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { HomePageProps } from '~/static_props/home'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage<HomePageProps> = () => {
  const { isLoading } = useRequireSignedIn()
  return (
    <DefaultLayout
      head={{
        title: 'お問い合せ',
      }}
      maxWidth={1000}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <h1 className="h3 mb-5">お問い合せ</h1>
          <Alert variant="warning" className="py-2">
            よくあるお問い合わせと対応状況は
            <Link href={HELP_NOTION_LINKS['PAST_INQUIRES']} target="_blank">
              こちら
            </Link>
          </Alert>
          <p>
            本フォームでは、お仕事のご依頼、不具合のご報告、ご意見・ご要望などの各種お問い合わせを受け付けております。ぜひお気軽にお問い合わせください。コンテンツの削除要求は、法律や利用規約に反するもの以外は原則対応することができません。
          </p>
          <p>
            通常は3営業日以内にお返事をしておりますが、現在、お問い合わせが殺到しており、少し対応までお時間を頂いております。また、運営が対応できないと判断したお問い合わせに関しては、お返事をすることはできません。
          </p>
          <hr />
          <InquiryForm app="mathlog" />
        </>
      )}
    </DefaultLayout>
  )
}

export default Page
